// Configuración para OneDrive/Microsoft Graph API
// Para configurar correctamente:
// 1. Ve a https://portal.azure.com/
// 2. Registra una nueva aplicación en Azure Active Directory
// 3. Configura las URLs de redirección
// 4. Obtén el Client ID de la aplicación
// 5. Configura los permisos necesarios para Microsoft Graph

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '2f4c1fa8-157e-4183-9e85-6811148e074e',
    authority: 'https://login.microsoftonline.com/organizations',
    redirectUri: import.meta.env.VITE_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

// Scopes necesarios para OneDrive
export const loginRequest = {
  scopes: [
    'User.Read',
    'Files.ReadWrite',
    'Files.ReadWrite.All'
  ],
};

// Configuración de Microsoft Graph
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
  graphDriveEndpoint: 'https://graph.microsoft.com/v1.0/me/drive',
};

// Configuración específica para el almacenamiento de actas
export const oneDriveConfig = {
  // Carpeta donde se guardarán las actas
  actasFolder: 'Actas_IETS',
  
  // Formato de nombre de archivo
  fileNameFormat: (acta) => {
    const fecha = acta.fecha instanceof Date 
      ? acta.fecha.toISOString().split('T')[0]
      : new Date(acta.fecha).toISOString().split('T')[0];
    
    const tipoActa = acta.tipoActa === 'OTRO' ? acta.tipoActaCustom : acta.tipoActa;
    const proyecto = acta.tipoProyectos && acta.tipoProyectos.length > 0 
      ? acta.tipoProyectos.join('_')
      : (acta.tipoProyecto || 'SinProyecto');
    
    return `Acta_${acta.numeroActa}_${tipoActa}_${proyecto}_${fecha}.pdf`;
  },
  
  // Configuración de subida
  uploadConfig: {
    conflictBehavior: 'replace', // 'fail', 'replace', 'rename'
    chunkSize: 1024 * 1024 * 4, // 4MB chunks para archivos grandes
  }
};

// Validación de configuración
export const validateConfig = () => {
  const errors = [];
  
  if (!msalConfig.auth.clientId || msalConfig.auth.clientId === 'YOUR_AZURE_CLIENT_ID_HERE') {
    errors.push('VITE_AZURE_CLIENT_ID no está configurado');
  }
  
  if (errors.length > 0) {
    console.warn('⚠️ Configuración de OneDrive incompleta:', errors);
    return false;
  }
  
  return true;
};